import React from 'react';
import PopularCourse from '../HomePages/PopularCourse/PopularCourse';

const SkillsPages = () => {
    return (
        <div className='container-fluid p-5'>
            <PopularCourse/>
        </div>
    );
};

export default SkillsPages;